<button (click)="showRouteDialog()" 
        [pTooltip]="tooltipName" 
        tooltipPosition="top" 
        class="pn-button pn-button-primary pn-button-xxs" 
        type="button">
    Add Route <i class="pi pi-plus" style="margin-left: 4px;"></i>
</button>

<p-dialog header="Create Route" [(visible)]="formPopupVisible" [draggable]="false" (onHide)="resetValues()" [modal]="true" [closable]="true"
  [style]="{width: '50vw', height:'75vh', 'overflow':'hidden'}">
  <form class="form px-3" [formGroup]="routeForm">
    <div class="row py-2">
      <div class="form-group col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="businessLocation">Business Location</label>
        <app-single-select-dropdown [className]="'blom-select'" [data]="businessLocationsList"
          formControlName="businessLocation" [placeholder]="'Select Business Location'" [width]="'100'" [height]="'48'"
          (selectionChange)="OnBLSelection($event)"></app-single-select-dropdown>
        <span *ngIf="formValue['businessLocation'].invalid && formValue['businessLocation'].touched"
          class="error-validation">
          Business Location is required.</span>
      </div>

      <div class="form-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="routeName">Route Name</label>
        <input id="routeName" style="padding: .80rem .75rem;" class="form-control" type="text" formControlName="routeName">
        <span *ngIf="formValue['routeName'].invalid && formValue['routeName'].touched" class="error-validation">Route
          Name is
          required.</span>
      </div>

      <div class="form-group col-lg-2 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="routeState py-2">Route State</label>
        <input id="routeState" style="padding: .80rem .75rem;" class="form-control" type="text" value="Sorting" readonly>
      </div>
    </div>

    <p-divider></p-divider>

    <div class="row py-2">
      <div class="form-group col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="routetype">Route Type</label>
        <app-single-select-dropdown formControlName="routetype" [data]="routeTypeOptions" [width]="'100'" [height]="'48'"
          [showClear]="true" [placeholder]="'Select Route Type'"></app-single-select-dropdown>
      </div>

      <div class="form-group col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="workshift">Workshift</label>
        <p-select optionLabel="name" #workshiftSelect
        [filter]="true" optionValue="workshift_id" formControlName="workshift"
          [style]="{'width':'100%',height:'48px'}" 
          (onFilter)="onWorkShiftFilter($event)"
          [showClear]="true"
          (onClear)="workShiftName = ''"
          (onChange)="handleWorkshiftChange($event)"
        [options]="workshiftList" placeholder="Select a workshift Id"  appendTo="body">
          <ng-template  pTemplate="footer">
            <div *ngIf="showAddWorkShiftFlag" class="d-grid gap-2">
              <button (click)="handleAddWorkshift()" class="btn btn-primary">{{workshiftFilterText}} ( Create Workshift )</button>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>

    <div class="row py-2">
      <div class="form-group col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="team">Teams</label>
        <app-single-select-dropdown formControlName="team" [data]="teamList" [width]="'100'" [height]="'48'"
          [showClear]="true" [placeholder]="'Select a team'"></app-single-select-dropdown>
      </div>

      <div class="form-group col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="vehicle">Vehicle No.</label>
        <p-select optionLabel="reg_no" optionValue="id" formControlName="vehicle" #vehicleSelect [style]="{'width':'100%',height:'48px'}"
          [options]="vehicleRegNo" 
          [filter]="true"
          [showClear]="true"
          (onFilter)="onVechileFilter($event)"
          (onClear)="onVehicleClear()"
          (onChange)="handleVehicleChange($event)"
          placeholder="Select a vehicle number" appendTo="body">
          <ng-template  pTemplate="footer">
            <div *ngIf="showAddVehicleFlag" class="d-grid gap-2">
              <button (click)="handleAddVehicle()" class="btn btn-primary">{{vehicleFilterText}} ( Create Vehicle )</button>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>

    <div class="row py-2" *ngIf="showVehicleTypeFlag">
      <div class="form-group col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="vehicleType">Vehicle Type</label>
        <p-select optionLabel="assetType" optionValue="assetOperationType" formControlName="vehicleType"
          [style]="{'width':'100%',height:'48px'}"
          [options]="vehicleTypeList"
          appendTo="body"
          placeholder="Select a vehicle type">
        </p-select>
        <span *ngIf="formValue['vehicleType'].invalid && formValue['vehicleType'].touched" class="error-validation">
          Vehicle Type is required.</span>
      </div>
    </div>

    <p-divider align="left">
      <div class="inline-flex">
        <i class="pi pi-calendar mr-4"></i>
        <b> Time Window</b>
      </div>
    </p-divider>
    <div class="row py-2">
      <div class="form-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="date">Date</label>
        <p-datepicker  icon="pi pi-chevron-down" [(ngModel)]="date" [style]="{'width':'100%'}" [readonlyInput]="true" [showIcon]="true"
          appendTo="body" inputId="date" formControlName="date" [minDate]="minimumDate"></p-datepicker>
        <span *ngIf="formValue['date'].invalid && formValue['date'].touched" class="error-validation">Date is
          required.</span>
      </div>
      <div class="form-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="begin">From</label>
        <p-datepicker inputId="timeonly" [style]="{'width':'100%'}" [timeOnly]="true" formControlName="begin"
          (onSelect)="onTimeChange()" appendTo="body"></p-datepicker>
        <span *ngIf="formValue['begin'].invalid && formValue['begin'].touched" class="error-validation">From is
          required.</span>
      </div>
      <div class="form-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <label class="form-label" for="end">To</label>
        <div class="position-relative">
          <p-datepicker inputId="timeonly" [style]="{'width':'100%'}" [timeOnly]="true" formControlName="end"
            (onSelect)="onTimeChange()" appendTo="body"></p-datepicker>
          
        </div>
        <span *ngIf="formValue['end'].errors?.['required'] && formValue['end'].touched" class="error-validation">To is
          required.</span>
         <span *ngIf="!formValue['end'].errors?.['required'] && formValue['end'].errors?.['invalidEndTime'] && formValue['end'].touched" class="error-validation">Must be greater than begin time</span>
      </div>
    </div>
  </form>
  <span class="px-3 py-4"><b>**Newly created options in the Vehicle and Workshift drodpowns will be saved only after clicking the 'Save'</b></span>
  <ng-template #footer>
    <button class="pn-button pn-button-primary pn-button-md me-1" (click)="save()">Save</button>
    <button class="pn-button pn-button-tertiary pn-button-md " (click)="resetValues(); formPopupVisible = false; ">Cancel</button>
  </ng-template>
</p-dialog>